import { IApplicationState } from '../../types/redux';

export function getRequestCallbackOpener(state: IApplicationState) {
  return state.requestCallback.opener;
}
